// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-menu{margin:auto;max-width:1140px;height:160px;display:flex;justify-content:center;align-items:center}.list-menu ul{width:100%;max-width:800px;display:flex;justify-content:space-between}.list-menu ul li{text-align:center}.list-menu ul li a{color:#000;font-size:15px;font-weight:700;text-decoration:none}@media only screen and (max-width:900px){.list-menu{display:none}}", ""]);
// Exports
module.exports = exports;
